// @flow
import axios from 'lib/defaultClient';

export const like = (partnerId: string) => axios.post(`/partners/${partnerId}/like`);

export const unlike = (partnerId: string) => axios.delete(`/partners/${partnerId}/like`);

export const getLikesCount = (partnerId: string) => axios.get(`/partners/${partnerId}/like`);



// WEBPACK FOOTER //
// ./src/lib/api/partners/like.js